import { z } from '@/libs/zod';

export const prizeSchema = z.object({
  name: z.string(),
  type: z.string(),
  isDrawn: z.boolean(),
  prizeUrls: z.string(),
  prizeValue: z.number(),
});

export const ticketByCartRaffleSchema = z.object({
  sequence: z.string(),
  winning: z.boolean(),
  prizes: z.array(prizeSchema),
  date: z.string(),
  id: z.string(),
  hasBeenScratched: z.boolean(),
});

export const userSchema = z.object({
  cpf: z.string(),
  phone: z.string(),
  name: z.string(),
});

export const ticketsByCartRaffleResponseSchema = z.object({
  data: z.array(ticketByCartRaffleSchema),
  prizeNames: z.array(z.string()),
  prizeUrls: z.array(z.string()),
  prizeValues: z.array(z.number()),
  ticketsToScratch: z.number(),
  totalCount: z.number(),
  urlScratcherBanner: z.string().optional(),
  user: userSchema,
  tickets: z
    .array(
      z.object({
        hasBeenScratched: z.boolean(),
        sequence: z.string(),
        prizes: z.array(z.any()),
        id: z.string(),
        winning: z.boolean(),
      }),
    )
    .optional(),
});

export type Prize = z.infer<typeof prizeSchema>;
export type TicketByCartRaffle = z.infer<typeof ticketByCartRaffleSchema>;
export type User = z.infer<typeof userSchema>;
export type TicketsByCartRaffleResponse = z.infer<
  typeof ticketsByCartRaffleResponseSchema
>;

export type TicketsByCartRaffleParams = {
  cartRaffleId: string;
  take: number;
  cpf: string;
  phone: string;
  hasBeenScratched: boolean;
};
